export enum FeedbackType {
  OpinionLeader = 'OpinionLeader',
  Project = 'Project',
  Organization = 'Organization',
}
